import { types } from 'mobx-state-tree'

export const User = types.model('User', {
  // May be null, if we are creating a new user.
  id: types.maybeNull(types.identifierNumber),
  name: types.string,
  email: types.string,
  admin: types.boolean,
})
